module.exports = __webpack_public_path__ + "static/media/trainings_1_mind_body_fitness.27dbc947.webp";